import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';

export const useGetSystemAdminDashboardMetricsQuery = () => {
  const { getSystemAdminDashboardMetrics } = useServicesContext();

  return useQuery({
    queryKey: ['GET_SYSTEM_ADMIN_DASHBOARD_METRICS'],
    queryFn: getSystemAdminDashboardMetrics,
  });
};
